// extracted by mini-css-extract-plugin
export default {"section":"Conclusion_section__SCLMe","headline":"Conclusion_headline__MdGBW","news":"Conclusion_news__oP9Eb","quote":"Conclusion_quote__U9v3S"};